module.exports = __webpack_public_path__ + "44a5a88641259cb317d2ce64af618d91.svg";